import { Button } from 'nzk-react-components'
import Icon from 'components/UI/Icon/Icon'
import Loader from 'components/UI/Loader/Loader'
import React, { Component } from 'react'
import { getParameterByName } from 'lib/qs'
import {
  Clipboard,
  ClipboardClip,
  ClipboardContainer,
  ErrorMessage,
  Field,
  Form,
  Label,
  PasswordForgotten,
  PreviousStepButton,
  StyledInput,
  Title,
  Wrapper
} from './ZooLogin.styles'

export default class Login extends Component {
  static propTypes = {}

  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {
      fieldErrors: [null],
      step: 0,
      userId: null,
      username: '',
      loading: false,
      errorMessage: undefined,
      googleErrorMessage: undefined,
      fromParent: false
    }
  }

  componentDidMount() {
    const params = new URLSearchParams(location.search)
    const username = params.get('username')
    if (username) {
      this.setState({ username, fromParent: true }, () => {
        this.onUsernameSubmit()
      })
    }
  }

  async onUsernameSubmit() {
    const data = await this.props.getUser(this.state.username.toLowerCase())
    if (!data.findUser) {
      return this.setState({
        fieldErrors: ["This username isn't correct"]
      })
    }
    this.setState({
      fieldErrors: [null],
      userId: data.findUser._id,
      step: data.findUser.hasPassword ? 1 : 2
    })
  }

  async onPasswordLoginSubmit() {
    this.setState({
      loading: true
    })
    this.props
      .login({
        username: this.state.username.toLowerCase(),
        password: this.passwordInput.value
      })
      .then(async (data) => {
        try {
          const loginRedirect = getParameterByName('redirect')
          if (loginRedirect) {
            window.location.assign(loginRedirect)
            return
          }
          this.props.router.push('/zoo/map')
        } catch (e) {
          this.setState({
            loading: false,
            errorMessage: e.message,
            fieldErrors: ['']
          })
        }
      })
      .catch(e => {
        this.setState({
          loading: false,
          errorMessage: 'Invalid email or password',
          fieldErrors: [
            'Incorrect password! Passwords are case sensitive - please check CAPS LOCK.'
          ]
        })
      })
  }

  async onPasswordRegisterSubmit() {
    this.setState({
      loading: true
    })
    this.props
      .initStudentPassword(this.state.userId, this.passwordInput.value)
      .then(async ({ data }) => {
        this.props
          .login({
            username: this.state.username.toLowerCase(),
            password: this.passwordInput.value
          })
          .then(async ({ data }) => {
            try {
              this.props.router.push('/zoo/map')
            } catch (e) {
              console.error(e)
              this.setState({
                loading: false,
                errorMessage: e.message
              })
            }
          })
      })
      .catch(e => {
        this.setState({
          loading: false,
          errorMessage: 'Invalid email or password'
        })
      })
  }

  onFormChange(values) {
    let formData = values
    this.props.changeLoginForm(formData)
  }

  renderEnterUsernameForm() {
    return (
      <div>
        <Form>
          <Field>
            <Label>Enter your username</Label>
            <StyledInput
              isWrong={this.state.fieldErrors[0]}
              placeholder="Username"
              ref={u => (this.usernameInput = u)}
              defaultValue={this.state.username}
              onChange={e => this.setState({ username: e.target.value })}
              onKeyPress={e => e.which == 13 && this.onUsernameSubmit()}
            />
            {this.state.fieldErrors[0] && (
              <ErrorMessage>{this.state.fieldErrors[0]}</ErrorMessage>
            )}
          </Field>
          <Button
            size="regular"
            theme='primary'
            onClick={this.onUsernameSubmit.bind(this)}
          >
            Continue
          </Button>
        </Form>
      </div>
    )
  }

  renderExistingUserForm() {
    return (
      <Form>
        <Field>
          <Label>Enter your password</Label>
          <StyledInput
            isWrong={this.state.fieldErrors[0]}
            ref={p => (this.passwordInput = p)}
            placeholder="Password"
            type="password"
            onKeyPress={e => e.which == 13 && this.onPasswordLoginSubmit()}
          />
          {this.state.fieldErrors[0] && (
            <ErrorMessage>{this.state.fieldErrors[0]}</ErrorMessage>
          )}
        </Field>
        <Button
          size="regular"
          theme='primary'
          onClick={this.onPasswordLoginSubmit.bind(this)}
        >
          Continue
        </Button>
        <PasswordForgotten>
          <p>Forgotten your password?</p>
          <p>
            Your parent or teacher can reset your password in{' '}
            <a
              href="https://dashboard.nightzookeeper.com"
              target="_blank"
              rel="noreferrer noopener"
            >
              their dashboard.
            </a>
          </p>
        </PasswordForgotten>
      </Form>
    )
  }

  renderNewUserForm() {
    return (
      <Form>
        <Field>
          <Label>{ this.state.fromParent ? `Create a password for ${this.state.username}` : 'Create your password'}</Label>
          <StyledInput
            isWrong={this.state.fieldErrors[0]}
            placeholder="Password"
            type="password"
            ref={p => (this.passwordInput = p)}
            onKeyPress={e => e.which == 13 && this.onPasswordRegisterSubmit()}
          />
          {this.state.fieldErrors[0] && (
            <ErrorMessage>{this.state.fieldErrors[0]}</ErrorMessage>
          )}
        </Field>
        <Button
          size="regular"
          theme='primary'
          onClick={this.onPasswordRegisterSubmit.bind(this)}
        >
          Continue
        </Button>
      </Form>
    )
  }

  previousStep() {
    this.setState({
      step: 0
    })
  }

  render() {
    return (
      <Wrapper>
        {this.state.loading && <Loader itemColor="#FFFFFF" itemSize={100} />}

        <ClipboardContainer ref={c => (this.clipboard = c)}>
          <ClipboardClip />
          <Clipboard>
            {this.state.step !== 0 && (
              <PreviousStepButton
                size="large"
                round
                color="#ccc"
                onClick={this.previousStep.bind(this)}
              >
                <Icon name="arrow-left" color="white" size="large" />
              </PreviousStepButton>
            )}
            <Title>Enter the Night Zoo</Title>
            {this.state.step === 0 && this.renderEnterUsernameForm()}
            {this.state.step === 1 && this.renderExistingUserForm()}
            {this.state.step === 2 && this.renderNewUserForm()}
          </Clipboard>
        </ClipboardContainer>
      </Wrapper>
    )
  }
}
